<template lang='pug'>
.base.light
  CursorCustom(:theme="theme")
  BaseView(
    :theme="theme"
    :appear="appear"
    :orientation="orientation"
    )
    PageFloors
</template>

<script>
import BaseView from "../../views/BaseView/index";
import CursorCustom from "../../components/elements/Cursor/index";
import PageFloors from "../../components/blocks/PageFloors/index";
export default {
  name: "FloorPlan",
  data() {
    return {
      type: "half",
      theme: "light",
      appear: "normal",
      orientation: "vertical"
    };
  },
  components: {
    BaseView,
    CursorCustom,
    PageFloors
  }
};
</script>

<style lang="sass" scoped>
@import "src/sass/general/page"
</style>
